module.exports = __webpack_public_path__ + "static/02_peeker-d5ecce1bc18d292189718b017e869d4e.gif";